module.exports = __webpack_public_path__ + "static/media/signature.dea3f26d.svg";